import { render, staticRenderFns } from "./Dasboard.vue?vue&type=template&id=61feca68&scoped=true&lang=pug"
import script from "./Dasboard.vue?vue&type=script&lang=js"
export * from "./Dasboard.vue?vue&type=script&lang=js"
import style0 from "./Dasboard.vue?vue&type=style&index=0&id=61feca68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61feca68",
  null
  
)

export default component.exports